import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44c90c04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper wrapper" }
const _hoisted_2 = { class: "training_buttons_wrapper" }
const _hoisted_3 = { ref: "download" }
const _hoisted_4 = { class: "training_select_wrapper" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 3,
  class: "position-relative"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "menu_img",
  src: "/assets/img/ellipsis.svg"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "menu" }
const _hoisted_10 = {
  key: 0,
  class: "wrapper_body"
}
const _hoisted_11 = { class: "filter_wrapper" }
const _hoisted_12 = { class: "filter" }
const _hoisted_13 = { src: "/assets/img/filter.svg" }
const _hoisted_14 = { class: "week_switch_wrapper" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "week_switch_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "week_switch_button_img",
  src: "/assets/img/arrow-right.svg"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "table_wrapper" }
const _hoisted_22 = { class: "timetable_header_mobile_wrapper_sticky" }
const _hoisted_23 = { class: "timetable_header_mobile_wrapper" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "timetable_header_mobile_week_day" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timestamp_header" }, null, -1))
const _hoisted_29 = { class: "timetable_wrapper" }
const _hoisted_30 = { class: "timetable_header" }
const _hoisted_31 = { class: "mt-1" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "training_title_wrapper" }
const _hoisted_34 = { class: "training_title" }
const _hoisted_35 = { class: "training_time" }
const _hoisted_36 = { class: "training_name" }
const _hoisted_37 = { class: "training_trainer_name" }
const _hoisted_38 = { class: "training_trainer_capacity" }
const _hoisted_39 = {
  key: 1,
  class: "wrapper_body"
}
const _hoisted_40 = { class: "filter_wrapper" }
const _hoisted_41 = { class: "filter" }
const _hoisted_42 = { class: "personal_week_switch_wrapper" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "week_switch_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "week_switch_button_img",
  src: "/assets/img/arrow-right.svg"
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "table_wrapper" }
const _hoisted_50 = { class: "timetable_header_mobile_wrapper_sticky" }
const _hoisted_51 = { class: "timetable_header_mobile_wrapper" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "timetable_header_mobile_week_day" }
const _hoisted_54 = { class: "flex" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timestamp_header" }, null, -1))
const _hoisted_57 = { class: "timetable_wrapper" }
const _hoisted_58 = { class: "timetable_header" }
const _hoisted_59 = { class: "mt-1" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_62 = { class: "training" }
const _hoisted_63 = { class: "flex" }
const _hoisted_64 = { class: "training_not_paid" }
const _hoisted_65 = { class: "training_time" }
const _hoisted_66 = { class: "training_trainer_name mt-2" }
const _hoisted_67 = { class: "training_name mt-1" }
const _hoisted_68 = { class: "training_service_name" }

export function render(_ctx, _cache) {
  const _component_createGroupTraining = _resolveComponent("createGroupTraining")
  const _component_createPesonalTraining = _resolveComponent("createPesonalTraining")
  const _component_viewGroupTraining = _resolveComponent("viewGroupTraining")
  const _component_viewPersonalTraining = _resolveComponent("viewPersonalTraining")
  const _component_copyingAlert = _resolveComponent("copyingAlert")
  const _component_v_select = _resolveComponent("v-select")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isShowCreateGroupTraining)
      ? (_openBlock(), _createBlock(_component_createGroupTraining, {
          key: 0,
          clubWithZone: _ctx.clubWithZone,
          trainingDate: _ctx.addTrainingDate,
          clubZoneId: _ctx.selectedClubZone.id,
          onClose: _ctx.closeAllWindows
        }, null, 8, ["clubWithZone", "trainingDate", "clubZoneId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isShowCreatePersonalTraining)
      ? (_openBlock(), _createBlock(_component_createPesonalTraining, {
          key: 1,
          clubWithZones: _ctx.clubWithZones,
          trainingDate: _ctx.addTrainingDate,
          selectedPersonalTrainerId: this.personalTrainer?.id,
          onClose: _ctx.closeAllWindows
        }, null, 8, ["clubWithZones", "trainingDate", "selectedPersonalTrainerId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isShowGroupTraining)
      ? (_openBlock(), _createBlock(_component_viewGroupTraining, {
          key: 2,
          training: _ctx.selectedGroupTraining,
          onClose: _ctx.closeAllWindows,
          onUpdateTraining: _ctx.updateTraining
        }, null, 8, ["training", "onClose", "onUpdateTraining"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPersonalTraining)
      ? (_openBlock(), _createBlock(_component_viewPersonalTraining, {
          key: 3,
          training: _ctx.selectedPersonalTraining,
          onClose: _ctx.closeAllWindows,
          onUpdateTraining: _ctx.updateTraining
        }, null, 8, ["training", "onClose", "onUpdateTraining"]))
      : _createCommentVNode("", true),
    (_ctx.isShowAlert)
      ? (_openBlock(), _createBlock(_component_copyingAlert, {
          key: 4,
          alertCopyingWeek: _ctx.alertCopyingWeek,
          alertPastedWeek: _ctx.alertPastedWeek,
          onSuccess: _ctx.copyTrainings,
          onCancel: _cache[0] || (_cache[0] = $event => (_ctx.isShowAlert = false))
        }, null, 8, ["alertCopyingWeek", "alertPastedWeek", "onSuccess"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("a", _hoisted_3, null, 512), [
          [_vShow, false]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.isShowGroupTrainings ? 'training_button_active' : 'training_button'),
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.isShowGroupTrainings = true))
          }, _toDisplayString(_ctx.$t('timetable.group_trainings')), 3),
          _createElementVNode("button", {
            class: _normalizeClass(!_ctx.isShowGroupTrainings ? 'training_button_active' : 'training_button'),
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.isShowGroupTrainings = false))
          }, _toDisplayString(_ctx.$t('timetable.personal_trainings')), 3)
        ]),
        _createElementVNode("div", _hoisted_5, [
          ((_ctx.isShowGroupTrainings && _ctx.hasCreateGroupPermission) || (!_ctx.isShowGroupTrainings && _ctx.hasCreatePersonalPermission))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "new_training",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.createTraining(null)))
              }, _toDisplayString(_ctx.$t('timetable.add_training')), 1))
            : _createCommentVNode("", true),
          (_ctx.hasPDFLoadPermission && _ctx.isShowGroupTrainings && !_ctx.hasCopyPermission)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "load_pdf",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
              }, _toDisplayString(_ctx.$t('timetable.load_pdf')), 1))
            : _createCommentVNode("", true),
          (_ctx.hasCopyPermission && _ctx.isShowGroupTrainings && !_ctx.hasPDFLoadPermission)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "load_pdf",
                onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.showCopyTrainingsAlert && _ctx.showCopyTrainingsAlert(...args)))
              }, _toDisplayString(_ctx.$t('timetable.copy_trainings')), 1))
            : _createCommentVNode("", true),
          (_ctx.hasCopyPermission && _ctx.isShowGroupTrainings && _ctx.hasPDFLoadPermission)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "menu_button",
                  onClick: _cache[6] || (_cache[6] = $event => (_ctx.isShowButtons = !_ctx.isShowButtons))
                }, _hoisted_8),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  (_ctx.hasPDFLoadPermission)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "menu_item",
                        onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                      }, _toDisplayString(_ctx.$t('timetable.load_pdf')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.hasCopyPermission)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "menu_item",
                        onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.showCopyTrainingsAlert && _ctx.showCopyTrainingsAlert(...args)))
                      }, _toDisplayString(_ctx.$t('timetable.copy_trainings')), 1))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _ctx.isShowButtons]
                ])
              ])), [
                [_directive_click_outside, _ctx.onClickOutside]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isShowGroupTrainings)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.isShowFilters ? 'show_filtes_mobile' : 'hide_filtes_mobile')
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedClubZone,
                    "onUpdate:modelValue": [
                      _cache[9] || (_cache[9] = $event => ((_ctx.selectedClubZone) = $event)),
                      _ctx.changeClubZone
                    ],
                    class: "club_zone_filter",
                    label: 'timetable.club_zone',
                    items: _ctx.clubZones
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filterClass,
                    "onUpdate:modelValue": [
                      _cache[10] || (_cache[10] = $event => ((_ctx.filterClass) = $event)),
                      _ctx.applyGroupFilter
                    ],
                    class: "classes_filter",
                    label: 'timetable.training_class',
                    items: _ctx.classes,
                    clearable: ""
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"]),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.filterTrainer,
                    "onUpdate:modelValue": [
                      _cache[11] || (_cache[11] = $event => ((_ctx.filterTrainer) = $event)),
                      _ctx.applyGroupFilter
                    ],
                    class: "w-100",
                    label: 'timetable.trainer',
                    items: _ctx.groupTrainers,
                    clearable: ""
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.clearAllGroupFilters && _ctx.clearAllGroupFilters(...args))),
                  class: "clear_all_filters pl-2"
                }, _toDisplayString(_ctx.$t('timetable.clear_all_filters')), 1)
              ])
            ], 2),
            _createElementVNode("button", {
              class: "filter_button",
              onClick: _cache[13] || (_cache[13] = $event => (_ctx.isShowFilters = !_ctx.isShowFilters))
            }, [
              _createTextVNode(_toDisplayString(!_ctx.isShowFilters ? _ctx.$t('timetable.filter') : _ctx.$t('timetable.hide')) + " ", 1),
              _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                [_vShow, !_ctx.isShowFilters]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.clickOnPreviousWeek && _ctx.clickOnPreviousWeek(...args))),
                class: "week_switch_button mr-1",
                disabled: _ctx.isLoading
              }, _hoisted_17, 8, _hoisted_15),
              _createElementVNode("button", {
                onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.clickOnNextWeek && _ctx.clickOnNextWeek(...args))),
                class: "week_switch_button",
                disabled: _ctx.isLoading
              }, _hoisted_20, 8, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupTrainingsTimetable, (weekDay, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(_ctx.mobileShowDay != index ? 'timetable_header_mobile' : 'timetable_header_mobile timetable_header_mobile_active'),
                      onClick: $event => (_ctx.mobileShowDay = index)
                    }, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t(weekDay.weekDay)), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.getFormatedDate(weekDay.date, 'DD')), 1)
                    ], 10, _hoisted_24))
                  }), 256))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_ctx.groupTrainingsTimetable?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupTrainingsTimetable[0]?.cells, (cell) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "timestamp",
                          style: _normalizeStyle({ height: `${_ctx.groupCellHeight}px` })
                        }, _toDisplayString(_ctx.getFormatedDate(cell.dateTime, 'HH:mm')), 5))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupTrainingsTimetable, (weekDay, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(_ctx.mobileShowDay != index ? 'week_day_wrapper week_day_wrapper_hide' : 'week_day_wrapper')
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t(weekDay.weekDay)), 1),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.getFormatedDate(weekDay.date, 'DD.MM.yyyy')), 1)
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDay.cells, (cell) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(cell.isDisable ? 'cell cell_disabled' : cell.isPassed  ? 'cell_passed' : cell.trainings.length > 0 ? 'cell' : 'empty_cell'),
                            style: _normalizeStyle({ height: `${_ctx.groupCellHeight}px` }),
                            onClick: $event => (_ctx.clickOnGroupTrainersCell(cell))
                          }, [
                            (cell.trainings.length > 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "training_wrapper",
                                  style: _normalizeStyle({ height: `calc(${_ctx.groupCellHeight}px * ${cell.trainings[0].numberOfCells} - 10px)`})
                                }, [
                                  _createElementVNode("div", {
                                    style: _normalizeStyle({ 'background-color': cell.trainings[0].trainingColor, color: cell.trainings[0].trainingTextColor }),
                                    class: "training"
                                  }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("p", _hoisted_35, _toDisplayString(cell.trainings[0].trainingTime), 1),
                                        _createElementVNode("p", _hoisted_36, _toDisplayString(cell.trainings[0].trainingClassName), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "trainer_photo",
                                        style: _normalizeStyle({ 'background-image': `url(${cell.trainings[0].trainerPhoto})` })
                                      }, null, 4)
                                    ]),
                                    _createElementVNode("p", _hoisted_37, _toDisplayString(cell.trainings[0].trainerName), 1),
                                    _createElementVNode("p", _hoisted_38, _toDisplayString(cell.trainings[0].load) + " " + _toDisplayString(_ctx.$t('timetable.out_of')) + " " + _toDisplayString(cell.trainings[0].capacity), 1)
                                  ], 4)
                                ], 4)), [
                                  [_vShow, cell.trainings[0].isShow]
                                ])
                              : _createCommentVNode("", true)
                          ], 14, _hoisted_32))
                        }), 256))
                      ])
                    ], 2))
                  }), 256))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isShowGroupTrainings)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.personalTrainer,
                    "onUpdate:modelValue": [
                      _cache[16] || (_cache[16] = $event => ((_ctx.personalTrainer) = $event)),
                      _ctx.selectPersonalTrainer
                    ],
                    class: "personal_trainer_filter",
                    label: 'timetable.trainer',
                    items: _ctx.personalTrainers
                  }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                onClick: _cache[17] || (_cache[17] = (...args) => (_ctx.clickOnPreviousWeek && _ctx.clickOnPreviousWeek(...args))),
                class: "week_switch_button mr-1",
                disabled: _ctx.isLoading
              }, _hoisted_45, 8, _hoisted_43),
              _createElementVNode("button", {
                onClick: _cache[18] || (_cache[18] = (...args) => (_ctx.clickOnNextWeek && _ctx.clickOnNextWeek(...args))),
                class: "week_switch_button",
                disabled: _ctx.isLoading
              }, _hoisted_48, 8, _hoisted_46)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalTrainingsTimetable, (weekDay, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(_ctx.mobileShowDay != index ? 'timetable_header_mobile' : 'timetable_header_mobile timetable_header_mobile_active'),
                      onClick: $event => (_ctx.mobileShowDay = index)
                    }, [
                      _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t(weekDay.weekDay)), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.getFormatedDate(weekDay.date, 'DD')), 1)
                    ], 10, _hoisted_52))
                  }), 256))
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                (_ctx.personalTrainingsTimetable?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _hoisted_56,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalTrainingsTimetable[0]?.cells, (cell) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "timestamp",
                          style: _normalizeStyle({ height: `${_ctx.personalCellHeight}px` })
                        }, _toDisplayString(_ctx.getFormatedDate(cell.dateTime, 'HH:mm')), 5))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalTrainingsTimetable, (weekDay, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(_ctx.mobileShowDay != index ? 'week_day_wrapper week_day_wrapper_hide' : 'week_day_wrapper')
                    }, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t(weekDay.weekDay)), 1),
                        _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.getFormatedDate(weekDay.date, 'DD.MM.yyyy')), 1)
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDay.cells, (cell) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(cell.isDisable ? 'cell cell_disabled' : cell.isPassed  ? 'cell_passed' : cell.trainings.length > 0 ? 'cell overflow_hidden' : 'empty_cell'),
                            style: _normalizeStyle({ height: `${_ctx.personalCellHeight}px` }),
                            onClick: $event => (_ctx.clickOnPersonalTrainersCell(cell))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.trainings, (training) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["training_wrapper", {show_full_personal_training: training.isShowFullTraining, hide_personal_training: training.isHideTraining}]),
                                style: _normalizeStyle({ height: `calc(${_ctx.personalCellHeight}px * ${training.numberOfCells} - 10px)`, left: `${training.left}%`, transition: 'left 0.3s ease-out 0.1s' }),
                                onClick: $event => (_ctx.clickOnPersonalTraining(training)),
                                onMouseenter: $event => (_ctx.mouseenterOnPersonalTraining(cell, training.trainingId)),
                                onMouseleave: $event => (_ctx.mouseleaveOnPersonalTraining(cell))
                              }, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _withDirectives(_createElementVNode("div", _hoisted_64, null, 512), [
                                      [_vShow, !training.isPaid]
                                    ]),
                                    _createElementVNode("p", _hoisted_65, _toDisplayString(training.trainingTime), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_66, _toDisplayString(training.trainerName), 1),
                                  _createElementVNode("p", _hoisted_67, _toDisplayString(training.clientrName), 1),
                                  _createElementVNode("p", _hoisted_68, _toDisplayString(training.serviceName), 1)
                                ])
                              ], 46, _hoisted_61))
                            }), 256))
                          ], 14, _hoisted_60))
                        }), 256))
                      ])
                    ], 2))
                  }), 256))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}